import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { FormGroup } from '@angular/forms';
import { RichLink } from './richLink';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { required } from '../../../../../../../shared/utils';

const NODE_TYPE = 'richLink';

@Component({
  selector: 'app-rich-link',
  templateUrl: './rich-link.component.html',
  styleUrls: ['./rich-link.component.scss']
})
export class RichLinkComponent extends NodeBuilder implements OnInit {

  richLinkForm: FormGroup = undefined;
  newStep = undefined;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.richLinkForm = RichLink.toForm(stepData, this.canEdit);

    if (this.richLinkForm.get('next').value === newStepValue) {
      this.newStep = 'step' + this.getNextStep();
      this.richLinkForm.get('next').setValue(this.newStep);
    }

    this.updateValidators(this.richLinkForm.get('previewType').value);
  }

  get getStepData(): {} {
    const richLink = new RichLink();
    const rawValue = this.richLinkForm.getRawValue();
    richLink.setMenu(rawValue);
    const nodeData = richLink.nodeData;
    nodeData['next'] = rawValue.next;

    return nodeData;
  }

  get isNodeValid(): boolean {
    this.richLinkForm.markAllAsTouched();
    return this.richLinkForm.valid;
  }

  public previewTypeChanged(event: MatButtonToggleGroup): void {
    this.richLinkForm.get('previewType').setValue(event.value);
    this.updateValidators(event.value);
  }

  setImage(event, form) {
    form.get('image').setValue(event);
  }

  private updateValidators(previewType: string): void {
    const videoUrl = this.richLinkForm.get('videoUrl');
    const videoMimeType = this.richLinkForm.get('videoMimeType');

    if (previewType === 'VIDEO') {
      videoUrl.setValidators([required('Video URL')]);
      videoMimeType.setValidators([required('Video MIME Type')]);
    } else {
      videoUrl.clearValidators();
      videoMimeType.clearValidators();
    }

    videoUrl.updateValueAndValidity();
    videoMimeType.updateValueAndValidity();
  }

  public isBodyEmpty(): boolean {
    const body = this.richLinkForm.get('body')?.value;
    return body === undefined || body === null || body === '';
  }
}
